// npm packages
import React, {
  useEffect,
  useContext,
  useState,
  useCallback,
  Fragment,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { toast } from "react-toastify";
import * as moment from "moment";
import { useTranslation } from 'react-i18next';
// custom pages
import config from "config/index";
import Context from "context/context";
import Table from "components/Table/Table";
import useDebounce from "helpers/useDebounce";
import "./Privilege.css";
import { privilegeStyles } from "./styles";
import PrivilegeAPI from "apis/privilege/privilege";
import Loader from "components/Loader/Loader";
import searchIcon from "assets/img/Search_Icon.png";
import editIcon from "assets/img/editIcon.png";
import maxMerch from "apis/maxmerch/maxmerch";
import AuditAPI from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Badge from "@material-ui/core/Badge";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";


// material-ui icons
import MenuIcon from "@material-ui/icons/Menu";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuItem from "@material-ui/core/MenuItem";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";

//Helpers
import { blockInvalidChar } from "helpers/blockInvalidChar";
import {dateFormat} from "helpers/dataFormat"
import { CSVLink } from "react-csv";
import { exportShiptoHeaders,exportBuildtoHeaders } from "./export";



// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
        marginTop: 0,
      },
    },
  },
})(TextField);

export default function Privilege(props) {
  const { state, dispatch } = useContext(Context);
  const {
    getPrivilege,
    updateLoyalty,
    searchPrivilege,
    filterPrivilege,
    getReasonDescription,
    handleShiptoExport,
    handleBilltoExport
  } = PrivilegeAPI();
  const { getAudit, getAuditTableConfig } = AuditAPI();

  const { getTier } = maxMerch();
  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);
  const [checkedActive, setCheckedActive] = useState(false);
  const [checkedinActive, setCheckedinActive] = useState(false);
  const [id, setid] = useState("");
  const [offset, setOffset] = useState(1);
  const [customer, setcustomer] = useState("");
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [viewMoreEnd, setViewMoreEnd] = useState("");
  const [NoData, setNoData] = useState(false);
  const [loading, setLoading] = useState();
  const [response, setResponse] = useState(false);
  const [exportData, setExportData] = useState([]);


  const classes = privilegeStyles();
  const [searchValue, setSearchValue] = useState(location?.searchValue || "");
  const [hover, setHover] = React.useState({ name: "", active: false });
  const searchBounceValues = useDebounce(searchValue);

  const [states, setstates] = useState({
    popover: false,
    filter: false,
    is_active: "",
    code_assignment: "",
    loading: false,
    shipto_loading: false,
    buildto_loading: false,
    exportBtn: false,
    editId: "",
    edit: false,
    editObj: {},
    tier: [],
    reasonDescription: [],
    updateObj: {},
    updateDialog: false,
    systemManagedDialog: false,
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const {
    tier,
    reasonDescription,
    editId,
    edit,
    editObj,
    updateObj,
    updateDialog,
    systemManagedDialog,
    historyLoader,
  } = states;

  const [mixedCodeDialog, setMixedCodeDialog] = useState({
    open: false,
    obj: {},
    index: null,
  });


  const handlePagination = (value) => {
    setOffset(value);
  };

  const callback = () => {
    setOffset(offset + 1);
  };

  const scrollRef = useBottomScrollListener(callback);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Setup Privilege Code"],
    });
  }, []);

  // tier api func
  useEffect(() => {
    handleGetTier();
    handleGetReason();
  }, []);

  // tier api func
  const handleGetTier = async () => {
    try {
      let res = await getTier();
      if (res) {
        setStates({ tier: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };


  // tier api func
  const handleGetReason = async () => {
    try {
      let res = await getReasonDescription();
      if (res) {
        setStates({ reasonDescription: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  useEffect(() => {
    if (location?.searchValue) {
      setSearchValue(location?.searchValue);
    }
  }, [location]);

  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      if (!filterCard) {
        states.filter
          ? handleFilter()
          : searchValue && searchValue.length > 0
            ? handleSearch()
            : getLoyalty();
      }
    }
  }, [state.userInfo, offset]);

  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    }
  }, [searchBounceValues]);

  const getLoyalty = async () => {
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      setStates({ loading: true });
      let res = await getPrivilege(values);
      if (res) {
        if (viewMore) {
          if (res.data.length == 0) {
            setViewMoreEnd("End of data");
          } else {
            setData([...data, ...res.data]);
            if (res.data.length < 10) {
              setNoData(true);
            }
          }
        } else {
          setData(res.data);
          if (res?.count == 0) {
            setNoData(true);
          }
          if (res?.count > 0) {
            if (res.data.length <= 10 && res?.count <= 10) {
              setNoData(true);
              setViewMoreEnd("End of data");
            }
          }
        }
        setResponse(true);
        setStates({ loading: false });
      }
    } catch (e) {
      console.log("errors");
    }
  };

  const handleSearch = async () => {
    try {
      let values;
      values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      setFilterCard(false);
      setStates({ filter: false });
      setStates({ loading: true });

      let res = await searchPrivilege(values);
      if (res) {
        if (viewMore) {
          if (res.data.length == 0) {
            setViewMoreEnd("End of data");
          } else {
            setData([...data, ...res.data]);
            if (res.data.length < 10) {
              setNoData(true);
            }
          }
        } else {
          setData(res.data);
          if (res?.count == 0) {
            setNoData(true);
          }
          if (res?.count > 0) {
            if (res.data.length <= 10 && res?.count <= 10) {
              setNoData(true);
              setViewMoreEnd("End of data");
            }
          }
        }
        setResponse(true);
        setStates({ loading: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };
  async function handleExport() {
    setStates({ shipto_loading: true });
    setStates({ exportBtn: true });
    try {
      let values = {};
      if (searchValue && searchValue.length > 0) {
        values = {
          ...values,
          searchValue: searchValue,
        };
      }
      if (states.filter) {
        if (typeof states.is_active === "boolean") {
          values = { ...values, is_active: states.is_active };
        }
        // if (states.code_assignment) {
        //   values = { ...values, code_assignment: states.code_assignment };
        // }
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await handleShiptoExport(values);
      if (res) {
        if (res?.data?.length == 0) {
          setStates({ shipto_loading: false });
          toast.success('No data found', { toastId: '#1' });
          return;
        }
        const formattedData = (res.data).map(item =>
          ({ ...item, created_at: " " + item?.created_at + " " })
        );
        setExportData(formattedData);
        setCount(res.count);
        setStates({ shipto_loading: false });
        dispatch({ type: "SET_LOADING", payload: false });
        return true;
      }
      setStates({ shipto_loading: false });
      toast.error(res && res.message ? res.message : "something went wrong");
      return false;
    } catch (e) {
      console.log("priviilage", { e });
      setStates({ shipto_loading: false });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }

  async function handleExportBillto() {
    setStates({ buildto_loading: true });
    setStates({ exportBtn: false });
    try {
      let values = {};
      if (searchValue && searchValue.length > 0) {
        values = {
          ...values,
          searchValue: searchValue,
        };
      }
      if (states.filter) {
        if (typeof states.is_active === "boolean") {
          console.log("loggedd")
          values = { ...values, is_active: states.is_active };
        }
        // if (states.code_assignment) {
        //   values = { ...values, code_assignment: states.code_assignment };
        // }
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await handleBilltoExport(values);
      if (res && res.type == "success") {
        if (res?.data?.length == 0) {
          setStates({ buildto_loading: false });
          toast.success('No data found', { toastId: '#1' });
          return;
        }
        const formattedData = (res.data).map(item =>
          ({ ...item, created_at: " " + item?.created_at + " " })
        );
        setExportData(formattedData);
        setCount(res.count);
        dispatch({ type: "SET_LOADING", payload: false });
        setStates({ buildto_loading: false });
        return true;
      }
      dispatch({ type: "SET_LOADING", payload: false });
      toast.error(res && res.message ? res.message : "something went wrong");
      setStates({ buildto_loading: false });
      return false;
    } catch (e) {
      console.log({ e });
      setStates({ buildto_loading: false });
      dispatch({ type: "SET_LOADING", payload: false });
      toast.error()
    }
  }

  const handleFilter = async () => {
    setStates({ loading: true });
    setSearchValue("");
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (typeof states.is_active === "boolean") {
        values = { ...values, is_active: states.is_active };
      }
      if (states.code_assignment) {
        values = { ...values, code_assignment: states.code_assignment };
      }
      let res = await filterPrivilege(values);
      if (res) {
        setStates({ filter: true });
        if (viewMore) {
          if (res.data.length == 0) {
            setViewMoreEnd("End of data");
          } else {
            setCount(res.count);
            setData([...data, ...res.data]);
            if (res.data.length < 10) {
              setNoData(true);
            }
          }
        } else {
          setData(res.data);
          setCount(res.count);
          if (res?.count == 0) {
            setNoData(true);
          }
          if (res?.count > 0) {
            if (res.data.length <= 10 && res?.count <= 10) {
              setNoData(true);
              setViewMoreEnd("End of data");
            }
          }
        }
        setFilterCard(false);
        setResponse(true);
        setStates({ loading: false });
      } else {
        setData([]);
        setFilterCard(false);
        setResponse(true);
        setStates({ loading: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };
  const handleUpdateLoyalty = async () => {
    try {
      //console.log("edit",editObj)
      if (!editObj?.tier) {
        toast.error("System Managed option cannot be updated until the tier is assigned.", {
          toastId: "missing-tier-error",
        });
        return;
      }
      
      let values = { loyaltyId: editId, tierReason: updateObj?.tierReason };

      if (updateObj?.tier) {
        values = {
          ...values,
          tier: updateObj?.tier,
        };
      }
      if (updateObj?.systemManaged) {
        values = {
          ...values,
          systemManaged: updateObj?.systemManaged,
        };
      }
   
      if (!(updateObj?.tier) && (editObj?.tier==''||!editObj?.tier)) {
       return toast.error("tier not assigned", {
          toastId: "update-error",
        });

      
    
      }
     
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await updateLoyalty(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setStates({
          editId: "",
          edit: false,
          editObj: {},
          updateObj: {},
          updateDialog: false,
        });
        toast.success("Updated", { tostId: "update-success" });
        if (offset === 1) {
          getLoyalty();
        } else {
          setOffset(1);
        }
      }
    } catch (e) {
      console.log("errors");
    }
  };

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "la",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // //console.log({ location });

  return (
    <React.Fragment>
      <Grid
        container
        className={classes.root}
        onClick={() => {
          filterCard == true && setFilterCard(false);
          !states.filter &&
            setStates({
              is_active: "",
              // code_assignment: "",
            });
        }}
      >
        {window.innerWidth < 600 && (
          <Grid xs={12}>
            <IconButton
              style={{ position: "absolute" }}
              onClick={() => {
                dispatch({ type: "SET_SIDEBAR", payload: true });
              }}
            >
              <MenuIcon />
            </IconButton>
            <span className={classes.headerText}>Privilege</span>
          </Grid>
        )}
        <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
          <CssTextField
            id="enterPassword"
            placeholder={t('Search for Loyalty Id')}
            type={"number"}
              onWheel={(e) => e.target.blur()}
            variant="outlined"
            autoComplete="off"
            onKeyDown={blockInvalidChar}
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setResponse(false);
                        setSearchValue("");
                        getLoyalty();
                        setData(data.slice(0, 10));
                        setOffset(1);
                        setViewMore(false);
                        setViewMoreEnd();
                        setNoData(false);
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              if (!e.target.value) {
                if (offset == 1) {
                  getLoyalty();
                } else {
                  setOffset(1);
                }
                setResponse(false);
                setData(data.slice(0, 10));
                setViewMoreEnd();
                setNoData(false);
                setViewMore(false);
              }
            }}
            onClick={() => {
              if (searchValue.length == 0) {
                setData(data.slice(0, 10));
                setOffset(1);
                setViewMore(false);
                setViewMoreEnd("");
                setNoData(false);
              }
            }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              data && data.length > 0 && setData(data.slice(0, 10));
              setFilterCard(!filterCard);
              setOffset(1);
              setViewMore(false);
              setViewMoreEnd("");
              setNoData(false);
              if (!states.filter) {
                setStates({
                  is_active: "",
                  code_assignment: "",
                });
              }
            }}
          >
            {t('Filter')}
            {states.filter && (
              <Badge
                badgeContent={count == 0 ? "" : count}
                classes={{ badge: classes.badge }}
                max={999}
              ></Badge>
            )}
          </Button>
          <button
            className={classes.exportBtn}
            style={{ marginLeft: 10 }}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
            disabled={states.shipto_loading}
          >
            {states.shipto_loading ? (
              <div class="snippet" style={{ marginLeft: 55 }}>
                <div class="stage">
                  <div class="dot-typing-e"></div>
                </div>
              </div>
            ) :
             t(`Shipto Export`)
            }
          </button>
          <button
            className={classes.exportBtn}
            style={{ marginLeft: 10 }}
            onClick={async () => {
              let res = await handleExportBillto();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {states.buildto_loading ? (
              <div class="snippet" style={{ marginLeft: 55 }}>
                <div class="stage">
                  <div class="dot-typing-e"></div>
                </div>
              </div>
            ) :
              t(`Billto Export`)
            }
          </button>
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={4} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={1}
                  className={classes.filterCardGridContainer}
                >
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    className={classes.filterCardGrid}
                    style={{ padding: "10px 10px 10px 15px" }}
                  >
                    <TextField
                      id={"Status"}
                      label={t('Status')}
                      select
                      fullWidth
                      type={"text"}
                      value={states.is_active}
                      onChange={(e) => {
                        setStates({ is_active: e.target.value });
                      }}
                    >
                      <MenuItem value={true}>{t('Active')}</MenuItem>
                      <MenuItem value={false}>{t('InActive')}</MenuItem>
                    </TextField>
                  </Grid>
                  {/* <Grid
                    item
                    xs={12}
                    sm={4}
                    className={classes.filterCardGrid}
                    style={{ padding: "10px 10px 10px 15px" }}
                  > */}
                    {/* <TextField
                      id={"Code Assignment"}
                      label={t('Code Assignment')}
                      select
                      fullWidth
                      type={"text"}
                      value={states.code_assignment}
                      onChange={(e) => {
                        setStates({ code_assignment: e.target.value });
                      }}
                    > */}
                      {/* <MenuItem value="New">{t('New')}</MenuItem>
                      <MenuItem value="Completely Assigned">
                        {t('Completely Assigned')}
                      </MenuItem>
                      <MenuItem value="Partially Assigned">
                        {t('Partially Assigned')}
                      </MenuItem>
                    </TextField>
                  </Grid> */}
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    className={classes.filterCardBtnGrid}
                    style={{ padding: 10 }}
                  >
                    <Button
                      className={classes.filterCardApplyBtn}
                      style={{
                        fontSize: 15,
                        height: 35,
                        marginTop: 0,
                      }}
                      onClick={() => {
                        handleFilter();
                      }}
                      disabled={
                        typeof states.is_active !== "boolean" &&
                        !states.code_assignment
                      }
                    >
                      {t('Apply')}
                    </Button>
                    </Grid>
                    <Grid
                    item
                    xs={12}
                    sm={4}
                    className={classes.filterCardBtnGrid}
                    style={{ padding: 10 }}
                  >

                    {states.filter && (
                      <Button
                        className={classes.filterCardResetBtn}
                        onClick={() => {
                          setStates({
                            is_active: false,
                            code_assignment: "",
                          });
                          setOffset(1);
                          setFilterCard(false);
                          setStates({ filter: false });
                          setCount();
                          getLoyalty();
                          setResponse(false);
                        }}
                      >
                        {t('Reset')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      {/* <Loader Loading={state.loading} top={"15%"}> */}
      {response ? (
        <div>
          <div className={viewMore ? classes.tableDiv : null} ref={scrollRef}>
            <Table
              headings={[
                "Loyalty Id",
                "Date of Enrollment",
                "Sales Summary Tier",
                // "Max Merch Tier",
                "Tier",
                // "Tier Override",
                "System Managed",
                "Active",
                // "Code Assignment",
                "Anniversary Start Date",
                "Anniversary End Date",
                state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? "Dormant Status" : "",
                state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? "Earning Status" : "",
                "Edit",
                "History",
              ]}
              data={
                // data.length > 0 ? (
                data.map((p, i) => [
                  [
                    p.loyalty_id ? (
                      <div
                        key={i}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            { data: p, search: searchValue }
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {p.loyalty_id}
                      </div>
                    ) : (
                      <span key={i} style={{ cursor: "pointer" }} />
                    ),
                  ],

                  [
                    p.created_at ? (
                      <div
                        key={i}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            {
                              data: p,
                              search: searchValue,
                            }
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {dateFormat(p.created_at, i18n.language)}
                      </div>
                    ) : (
                      <span key={i} style={{ cursor: "pointer" }} />
                    ),
                  ],
                  [
                    p.sales_summary_tier ? (
                      <div
                        key={i}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            {
                              data: p,
                              search: searchValue,
                            }
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {t(p.sales_summary_tier)}
                      </div>
                    ) : (
                      <span key={i} style={{ cursor: "pointer" }} />
                    ),
                  ],
                  // [
                  //   p.max_merch_tier ? (
                  //     <div
                  //       key={i}
                  //       onClick={() => {
                  //         history.push(
                  //           "/dashboard/view-loyalty-account-shipto",
                  //           {
                  //             data: p,
                  //             search: searchValue,
                  //           }
                  //         );
                  //       }}
                  //       style={{ cursor: "pointer" }}
                  //     >
                  //       {t(p.max_merch_tier)}
                  //     </div>
                  //   ) : (
                  //     <span key={i} style={{ cursor: "pointer" }} />
                  //   ),
                  // ],
                  [
                    editId === p?.loyalty_id &&
                      edit &&
                      editObj?.systemManaged !== "YES" ? (
                      <CssTextField
                        variant="outlined"
                        select
                        fullWidth
                        style={{ width: "100%" }}
                        value={editObj?.tier}
                        onChange={(e) => {
                          setStates({
                            editObj: { ...editObj, tier: e.target.value },
                            updateObj: { ...updateObj, tier: e.target.value },
                          });
                        }}
                      >
                        {tier.length > 0 &&
                          tier.map((i, j) => (
                            <MenuItem value={i.tier} key={j}>
                              {t(i.tier)}
                            </MenuItem>
                          ))}
                      </CssTextField>
                    ) : p.tier ? (
                      <div
                        key={i}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            {
                              data: p,
                              search: searchValue,
                            }
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {t(p.tier)}
                      </div>
                    ) : (
                      <span key={i} style={{ cursor: "pointer" }} />
                    ),
                  ],
                  // [
                  //   editId === p?.loyalty_id && edit && !p.override_flag ? (
                  //     <CssTextField
                  //       variant="outlined"
                  //       select
                  //       fullWidth
                  //       style={{ width: "100%" }}
                  //       value={editObj?.overrideFlag}
                  //       onChange={(e) => {
                  //         setStates({
                  //           editObj: {
                  //             ...editObj,
                  //             overrideFlag: e.target.value,
                  //           },
                  //           updateObj: {
                  //             ...updateObj,
                  //             overrideFlag: e.target.value,
                  //           },
                  //         });
                  //       }}
                  //     >
                  //       <MenuItem value={true}>{"Yes"}</MenuItem>
                  //       <MenuItem value={false}>{"No"}</MenuItem>
                  //     </CssTextField>
                  //   ) : p.override_flag ? (
                  //     <div
                  //       style={{ cursor: "pointer" }}
                  //       onClick={() => {
                  //         history.push(
                  //           "/dashboard/view-loyalty-account-shipto",
                  //           { data: p }
                  //         );
                  //       }}
                  //     >
                  //       Yes
                  //     </div>
                  //   ) : (
                  //     <div
                  //       style={{ cursor: "pointer" }}
                  //       onClick={() => {
                  //         history.push(
                  //           "/dashboard/view-loyalty-account-shipto",
                  //           { data: p }
                  //         );
                  //       }}
                  //     >
                  //       No
                  //     </div>
                  //   ),
                  // ],
                  [
                    editId === p?.loyalty_id && edit ? (
                    
                      <CssTextField
                        variant="outlined"
                        select
                        fullWidth
                        style={{ width: "100%" }}
                        value={t(editObj?.systemManaged)}
                        onChange={(e) => {
                          delete updateObj["tier"];
                          if (e.target.value === "NO") {
                            setStates({
                              systemManagedDialog: true,
                              editObj: {
                                ...editObj,
                                systemManaged: e.target.value,
                                tier: p?.tier,
                              },
                              updateObj: {
                                ...updateObj,
                                systemManaged: e.target.value,
                              },
                            });
                          } else {
                            setStates({
                              editObj: {
                                ...editObj,
                                systemManaged: e.target.value,
                                tier: p?.tier,
                              },
                              updateObj: {
                                ...updateObj,
                                systemManaged: e.target.value,
                              },
                            });
                          }
                        }}
                      >
                        <MenuItem value={"YES"}>{t("Yes")}</MenuItem>
                        <MenuItem value={"NO"}>{t("No")}</MenuItem>
                        <MenuItem value={"TEMP"}>{"Temp"}</MenuItem>
                      </CssTextField>
                    ) : (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            { data: p, search: searchValue }
                          );
                        }}
                      >
                        {p.system_managed
                          ? t(p.system_managed.charAt(0).toUpperCase() +
                            p.system_managed.slice(1).toLowerCase())
                          : "-"}
                      </div>
                    ),
                  ],
                  [
                    p.is_active ? (
                      <div
                        style={{ color: "green", cursor: "pointer" }}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            { data: p, search: searchValue }
                          );
                        }}
                      >
                        {t("Active")}
                      </div>
                    ) : (
                      <div
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            { data: p, search: searchValue }
                          );
                        }}
                      >
                        InActive
                      </div>
                    ),
                  ],
                  // [
                  //   p.code_assignment ? (
                  //     <div
                  //       key={i}
                  //       onClick={() => {
                  //         history.push(
                  //           "/dashboard/view-loyalty-account-shipto",
                  //           {
                  //             data: p,
                  //             search: searchValue,
                  //           }
                  //         );
                  //       }}
                  //       style={{
                  //         cursor: "pointer",
                  //         color:
                  //           (p.code_assignment == "New" && "red") ||
                  //           (p.code_assignment == "Completely Assigned" &&
                  //             "Green"),
                  //         // || p.code_assignment == "Partially Assigned" && "Black"
                  //       }}
                  //     >
                  //       {p.code_assignment}
                  //     </div>
                  //   ) : (
                  //     <span key={i} style={{ cursor: "pointer" }} />
                  //   ),
                  // ],
                  [
                    p.tier_start_date ? (
                      <div
                        key={i}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            {
                              data: p,
                              search: searchValue,
                            }
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {dateFormat(p.tier_start_date, i18n.language)}
                      </div>
                    ) : (
                      <span key={i} style={{ cursor: "pointer" }} />
                    ),
                  ],
                  [
                    p.tier_end_date ? (
                      <div
                        key={i}
                        onClick={() => {
                          history.push(
                            "/dashboard/view-loyalty-account-shipto",
                            {
                              data: p,
                              search: searchValue,
                            }
                          );
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {dateFormat(p.tier_end_date, i18n.language)}
                      </div>
                    ) : (
                      <span key={i} style={{ cursor: "pointer" }} />
                    ),
                  ],
                  state.userInfo?.loyalty_organization_name === "Henry Schein Dental"
                  ? [
                      p?.dormant_account_flag ? (
                        <div
                          style={{cursor: "pointer" }}
                          onClick={() =>
                            history.push("/dashboard/view-loyalty-account-shipto", {
                              data: p,
                              search: searchValue,
                            })
                          }
                        >
                          {t("Active")}
                        </div>
                      ) : (
                        <div
                          style={{cursor: "pointer" }}
                          onClick={() =>
                            history.push("/dashboard/view-loyalty-account-shipto", {
                              data: p,
                              search: searchValue,
                            })
                          }
                        >
                          {t("-")}
                        </div>
                      )
                    ]
                  : [""],
                
                  state.userInfo?.loyalty_organization_name === "Henry Schein Dental"
                  ? [
                      p.mktcls_modified ? (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            history.push("/dashboard/view-loyalty-account-shipto", {
                              data: p,
                              search: searchValue,
                            })
                          }
                        >
                          {t("No")}
                        </div>
                      ) : (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            history.push("/dashboard/view-loyalty-account-shipto", {
                              data: p,
                              search: searchValue,
                            })
                          }
                        >
                          Yes
                        </div>
                      )
                    ]
                  : [""],                
                 
                  [
                    p?.is_active ? (
                      editId === p?.loyalty_id && edit ? (
                        <React.Fragment>
                          <div style={{ display: "inline-flex" }}>
                            <CheckCircleOutlineIcon
                              style={{
                                cursor: "pointer",
                                color: "green",
                                margin: "0px 5px",
                                fontSize: 35,
                              }}
                              onClick={() => {
                                
                                if (
                                  (p?.tier === updateObj.tier ||
                                    p?.tier === editObj.tier) &&
                                  (p?.system_managed ===
                                    updateObj?.systemManaged ||
                                    p?.system_managed ===
                                    editObj?.systemManaged)
                                ) {
                                  toast.error("Please update any field", {
                                    toastId: "update-error",
                                  });
                                  return;
                                }
                              
                              //   const codes = p.privilege_codes
                              //   ? p.privilege_codes.split(",").map((c) => c.trim())
                              //   : [];
                              // console.log(codes,"code")
                              // if (codes.includes("ST3")) {
                              //   // Open mixed code dialog
                              //   setMixedCodeDialog({ open: true, obj: p, index: i });
                              //   return;
                              // }
                               
                                // if (p?.tier == null && updateObj?.systemManaged == 'NO') {
                                //   toast.error("Cannot set System Managed as NO without any Tier", {
                                //     toastId: "update-error",
                                //   });
                                //   return;
                                // }
                                setStates({ updateDialog: true });
                              }}
                            />
                            <HighlightOffIcon
                              style={{
                                cursor: "pointer",
                                color: "red",
                                margin: "0px 5px",
                                fontSize: 35,
                              }}
                              onClick={() => {
                                setStates({
                                  editId: "",
                                  edit: false,
                                  editObj: {},
                                  updateObj: {},
                                });
                              }}
                            />
                          </div>
                        </React.Fragment>
                      ) : (
                        <div
                          style={{ cursor: "pointer" }}
                          aria-disabled={!state?.userInfo?.editAction}
                          onClick={() => {
                            const dormantFlag = p?.dormant_account_flag === true 
                            const dormantProcessed = p?.dormant_processed === true
                            if (dormantFlag === true && dormantProcessed === true ) {
                              toast.error("Privilege Code cannot be updated for dormant customers. Reactivate their account in the 'Manage My Account' screen to proceed further.");
                            return;
                            }
                            
                              if (dormantFlag === true && dormantProcessed === false ) {
                                  toast.error("Privilege Code cannot be updated for dormant customers.");
                                return;
                                }
                            if (state?.userInfo?.editAction) {
                              setStates({
                                editId: p?.loyalty_id,
                                edit: true,
                                editObj: {
                                  tier: p?.tier,
                                  systemManaged: p?.system_managed,
                                },
                              });
                              return;
                            }
                            else {
                              toast.error(state?.userInfo?.editAccess)
                              return;
                            }
                          }}
                        >
                          <img src={editIcon} alt="" width="20" />
                        </div>
                      )
                    ) : (
                      "-"
                    ),
                  ],
                  (state?.userInfo?.auditAccess) && (
                    <HistoryIcon
                      style={{ cursor: "pointer", verticalAlign: "middle" }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(p?.loyalty_id);
                      }}
                    />
                  ),
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
              disablePagination={true}
            />
          </div>
          {data && data.length > 6 && !NoData && viewMore == false && (
            <div
              className={classes.viewMore}
              style={{ fontSize: 20 }}
              onClick={() => {
                setViewMore(true);
                setOffset(offset + 1);
              }}
            >
              {t('View More Activity')}
            </div>
          )}
          {viewMoreEnd && viewMoreEnd.length > 0 && (
            <div className={classes.viewMoreEnd}>{viewMoreEnd}</div>
          )}
        </div>
      ) : (
        <Loader Loading={!response} top={"15%"}></Loader>
      )}
      {/* Update dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={updateDialog}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>{t('Confirmation')}</div>
          <br />
          <Fragment>
            <div className={classes.subParentText}>
              {t('Please choose the reason for updating')}
              <span style={{ color: "red" }}>*</span>
            </div>
            <div>
              <CssTextField
                variant="outlined"
                select
                fullWidth
                className={classes.dialogInput}
                value={editObj?.tierReason}
                onChange={(e) => {
                  if (e.target.value === "Others") {
                    setStates({
                      editObj: {
                        ...editObj,
                        tierReason: e.target.value,
                      },
                      updateObj: { ...updateObj, tierReason: "" },
                    });
                  } else {
                    setStates({
                      editObj: {
                        ...editObj,
                        tierReason: e.target.value,
                      },
                      updateObj: { ...updateObj, tierReason: e.target.value },
                    });
                  }
                }}
              >
                {updateObj?.systemManaged === "YES"
                  ? reasonDescription
                    .filter((r) => r?.type === "PRIVILEGE_2")
                    ?.map((d, i) => (
                      <MenuItem value={d?.reason_description} key={i}>
                        {t(d?.reason_description)}
                      </MenuItem>
                    ))
                  : reasonDescription
                    .filter((r) => r?.type === "PRIVILEGE_1")
                    ?.map((d, i) => (
                      <MenuItem value={d?.reason_description} key={i}>
                        {t(d?.reason_description)}
                      </MenuItem>
                    ))}
              </CssTextField>

              {editObj.tierReason === "Others" && (
                <Fragment>
                  <div className={classes.subParentText}>
                    {t('Type the Reason')}&nbsp;<span style={{ color: "red" }}>*</span>
                    &nbsp;
                    <span style={{ fontSize: 12 }}>(Max 120 Characters)</span>
                  </div>
                  <CssTextField
                    id="reason"
                    type={"text"}
                    autoComplete="off"
                    variant="outlined"
                    inputProps={{
                      maxLength: 120,
                    }}
                    className={classes.dialogInput}
                    value={updateObj?.tierReason}
                    onChange={(e) => {
                      setStates({
                        updateObj: { ...updateObj, tierReason: e.target.value },
                      });
                    }}
                  />
                </Fragment>
              )}
            </div>
          </Fragment>
          <br />
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setStates({
                    editId: "",
                    edit: false,
                    editObj: {},
                    updateObj: {},
                    updateDialog: false,
                  });
                }}
              >
                {t('Cancel')}
              </Button>
            </Grid>
            <Grid item xs={6} className={classes.proceedBtnGrid}>
              <Button
                className={classes.proceedBtn}
                disabled={state?.loading}
                onClick={() => {
                  if (!updateObj?.tierReason) {
                    return toast.error("Please fill the reason", {
                      toastId: "empty-reason",
                    });
                  }
                  handleUpdateLoyalty();
                }}
              >
                {t('Update')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
      {/* Mixed Privilege Code Dialog */}
        {/* <Dialog
          open={mixedCodeDialog.open}
          onClose={() => setMixedCodeDialog({ open: false, obj: {}, index: null })}
          maxWidth="sm"
          style={{ fontFamily: "Segoe-ui" }}
        >
        <div style={{ padding: 20 }}>
          <h2 style={{ marginBottom: 10 }}>
            <span>{t("Mixed Privilege Code Detected")}</span>
          </h2>
          <p>
            {t(
              "The selected member has a combination of privilege codes (e.g., ST3). Do you still want to proceed with moving them to the Thrive/Midmarket privilege code?"
            )}
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
            <Button
              variant="outlined"
              style={{ marginRight: 10 }}
              onClick={() => setMixedCodeDialog({ open: false, obj: {}, index: null })}
            >
              {t("No")}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                // Close mixed dialog
                setMixedCodeDialog({ open: false, obj: {}, index: null });
                setStates({ updateDialog: true });
                //updateDialog({ open: true, obj: {}, index: null });
  
              }}
              >
             {t("Yes")}
            </Button>
          </div>
        </div>
      </Dialog> */}

      {/* System Managed dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={systemManagedDialog}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>
            {" "}
            {t('By selecting NO, you are permanently assigning the member your chosen status. Do you want to proceed?')}
          </div>
          <br />
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setStates({
                    systemManagedDialog: false,
                    editId: "",
                    edit: false,
                    editObj: {},
                    updateObj: {},
                  });
                }}
              >
                {t('No')}
              </Button>
            </Grid>
            <Grid item xs={6} className={classes.proceedBtnGrid}>
              <Button
                className={classes.proceedBtn}
                onClick={() => {
                  setStates({
                    systemManagedDialog: false,
                  });
                }}
              >
                {t('Yes')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>

      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
                "Reason Code",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                  d?.reason,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
      <CSVLink
        id="csv"
        data={exportData}
        headers = {
          states.exportBtn
            ? (state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental')
              ? [
                  ...exportShiptoHeaders,
                  { label: "Signature Flag",key: "signature_flag"},
                  { label: "Signature Start Date",key: "signature_start_date"},
                  { label: "Signature End Date",key: "signature_end_date"},
                  { label: 'Earning Status', key: 'mktcls_modified' },
                  { label: 'Dormant Status', key: 'dormant_account_flag' },
                  {label:'Dormant Processed', key:'dormant_processed'},
                  { label: "Service Plus Flag",key: "service_plus_flag"},
                  { label: "Service Plus Start Date",key: "Service_plus_start_date"},
                  { label: "Service Plus End Date",key: "Service_plus_end_date"},
                  { label: "Startup Flag",key: "Startup_Flag"},
                  { label: "Startup Start Date",key: "Startup_Start_Date"},
                  { label: "Startup End Date",key: "Startup_End_Date"},
                  {  label: "Unlock Flag",  key: "unlock_Flag"  },
                  {  label: "Unlock Start Date",key: "unlock_Start_Date" },
                 { label: "Unlock End Date", key: "unlock_End_Date"   }
                ]
              : (state?.userInfo?.loyalty_organization_name === 'Henry Schein Canada')
                ? [
                    ...exportShiptoHeaders
                  ]
                : exportShiptoHeaders
            : (state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental')
              ? [
                  ...exportBuildtoHeaders,
                  { label: 'Earning Status', key: 'mktcls_modified' },
                  { label: 'Dormant Status', key: 'dormant_account_flag' },
                  { label: 'GEP Date', key: 'cdr_gep' },
                  {label:'Dormant Processed', key:'dormant_processed'},
                  {label:'Reactivation Date', key:'reactivation_date'}
                ]
              : (state?.userInfo?.loyalty_organization_name === 'Henry Schein Canada')
                ? [
                    ...exportBuildtoHeaders,
                    { label: 'GEP Date', key: 'cdr_gep' }
                  ]
                : exportBuildtoHeaders
        }
        
                  
        filename={
          ((states.exportBtn ? t('Shipto Privilege') : t('Billto Privilege')))
          +
          " " +
          moment(new Date()).format("MM-DD-YYYY,h:mm A") +
          ".csv"
        }
        className={classes.CSVlink}
      />
    </React.Fragment>
  );
}
